import { UserManager, WebStorageStateStore } from 'oidc-client';
 
export default class AuthService {
    userManager;
 
    constructor() { 
        const STS_DOMAIN = process.env.VUE_APP_AUTH_URL;
 
        const settings = {
            userStore: new WebStorageStateStore({ store: window.localStorage }),
            authority: STS_DOMAIN,
            client_id: process.env.VUE_APP_CLIENT_ID,
            redirect_uri: process.env.VUE_APP_REDIRECT_BASE_URL +'callback.html',
            automaticSilentRenew: true,
            silent_redirect_uri: process.env.VUE_APP_REDIRECT_BASE_URL +'silent-renew.html',
            response_type: 'code',
            scope: 'openid profile email',
            post_logout_redirect_uri: process.env.VUE_APP_REDIRECT_BASE_URL +'?tenant='+localStorage.getItem('receipt_tenant')+'&'+localStorage.getItem('receipt_params'),
            filterProtocolClaims: true,
        };
 
        this.userManager = new UserManager(settings);
    }
 
    getUser() {
        return this.userManager.getUser();
    }
 
    login() {
        return this.userManager.signinRedirect();
    }
 
    logout() {
        return this.userManager.signoutRedirect();
    }
 
    getAccessToken() {
        return this.userManager.getUser().then((data) => {
            return data.access_token;
        });
    }
}